import { GenericHeader, SearchBar } from 'components';
import ListComp from 'components/ListComp';
import React from 'react';
import { Routine } from 'services';
import { Results, CreateModal } from './components';
import { curriculum_manager } from 'utils/constants';
import { Button } from '@material-ui/core';

const RoutineList = props => {
  let { mmodule } = props;
  const Head = props => {
    let { handleCreateOpen, ...rest } = props; // eslint-disable-line
    if (mmodule) return (
      <GenericHeader subheader={`Routines for ${mmodule.name_en}`} >
        <Button color="primary" onClick={handleCreateOpen} variant="contained">
          Add Routine
        </Button>
      </GenericHeader>
    );
    return (
      <GenericHeader header="All Routines" subheader="Routines Management" {...rest} />
    );
  }

  return (
    <ListComp
      listing={Routine.list}
      title="Routines"
      name="routines"
      searchable
      SearchBar={SearchBar}
      Header={Head}
      CreateComp={CreateModal}
      Results={Results}
      roles={[curriculum_manager]}
      filters={{ limit: 10, offset: 0, count: 0, search: "", module: mmodule ? mmodule.id : null }}
      comp_props={{ create_comp: { module_id: mmodule ? mmodule.id : null } }}
    />
  );
};

export default RoutineList;
